import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[CurrencyFormatter]'
})
export class GeneralCurrencyFormatterDirective {

  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef, private control: NgControl) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.formatValue(this.control.control?.value);
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    this.formatValue(value);
  }

  private formatValue(value: string | number): void {

    // Eliminar el símbolo $ y puntos, luego convertir comas a puntos
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[$,.]/g, '')) : value;
    if (!isNaN(numericValue)) {
      this.control.control?.setValue(numericValue);
      this.el.value = '$' + new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(numericValue);
    } else {
      this.control.control?.setValue(null);
      this.el.value = '';
    }
  }
}